import React from 'react';

interface CreativeCardProps {
  imageSrc: string;
  stats: { label: string; value: string }[];
  detailsLink: string;
  isVideo?: boolean;
}

const CreativeCard: React.FC<CreativeCardProps> = ({ 
  imageSrc, 
  stats, 
  detailsLink,
  isVideo = false 
}) => {
  return (
    <div className="flex flex-col lg:flex-row border rounded-lg bg-white shadow-sm overflow-hidden h-full">
      {/* Video/Image Section - Improved with better image handling */}
      <div className="relative w-full lg:w-1/2 aspect-video bg-gray-100">
        {imageSrc ? (
          <>
            <img 
              src={imageSrc} 
              alt="Creative preview" 
              className="w-full h-full object-contain bg-black"
              onError={(e) => {
                (e.target as HTMLImageElement).src = 'https://placehold.co/600x400?text=Preview+Not+Available';
                (e.target as HTMLImageElement).className = 'w-full h-full object-cover bg-gray-200';
              }}
            />
            {isVideo && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                <button className="bg-white p-3 rounded-full shadow-md hover:scale-105 transition-transform">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-6 h-6 text-black"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                    />
                  </svg>
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-200">
            <span className="text-gray-500">No preview available</span>
          </div>
        )}
      </div>

      {/* Stats Section */}
      <div className="flex flex-col p-4 space-y-4 w-full lg:w-1/2">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="flex justify-between items-center text-sm font-semibold text-black font-inter border border-[#00000029] rounded-[10px] px-4 py-3"
          >
            <span className="truncate pr-2">{stat.label}</span>
            <span className="font-normal text-[#4A4D4F] whitespace-nowrap">{stat.value}</span>
          </div>
        ))}
        <a
          href={detailsLink}
          className="text-blue-500 text-sm underline underline-offset-2 font-medium hover:text-blue-700 transition-colors"
        >
          View details
        </a>
      </div>
    </div>
  );
};

export default CreativeCard;